<template>
  <div :class="['sidebar', { collapsed, open: mobileOpen }]">
    <!-- Menu Items -->
    <ul class="menu" v-if="!isAdminRoute">
      <li v-for="item in menuGames" :key="item.label" @click="$emit('close-mobile')">
        <router-link :to="item.path" class="menu-item">
          <component :is="item.icon" class="menu-icon" />
          <span v-if="!collapsed">{{ item.label }}</span>
        </router-link>
      </li>
      <li class="menu-item-separator"></li>
      <li>
        <button class="menu-item" @click="goRain">
          <ChatIcon class="menu-icon" />
          <span v-if="!collapsed" class="menu-label">Rain</span>
        </button>
      </li>
      <li v-for="item in menuExtra" :key="item.label" @click="$emit('close-mobile')">
        <router-link :to="item.path" class="menu-item">
          <component :is="item.icon" class="menu-icon" />
          <span v-if="!collapsed" class="menu-label">{{ item.label }}</span>
        </router-link>
      </li>
    </ul>
    <ul class="menu" v-else>
      <li v-for="item in menuAdmin" :key="item.label" @click="$emit('close-mobile')">
        <router-link :to="item.path" class="menu-item" :class="{ active: isActive(item.path) }">
          <component v-if="item.icon" :is="item.icon" class="menu-icon" />
          <span v-if="!collapsed">{{ item.label }}</span>
          <span v-else-if="!item.icon" class="menu-icon">{{ item.label[0] }}</span>
        </router-link>
      </li>
    </ul>


    <!-- Collapse Button -->
    <button class="collapse-btn" @click="toggleSidebar">
      <ChevronLeftIcon v-if="!collapsed" class="menu-icon" />
      <ChevronLeftIcon
        v-else
        class="menu-icon"
        style="transform: rotate(180deg)"
      />
    </button>
  </div>
</template>

<script>
import IconHome from "@/components/icons/IconHome.vue";
import IconCrash from "@/components/icons/IconCrash.vue";
import IconRoll from "@/components/icons/IconRoll.vue";
import IconBlackjack from "@/components/icons/IconBlackjack.vue";
import IconBattles from "@/components/icons/IconBattles.vue";
import IconDuels from "@/components/icons/IconDuels.vue";
import IconMines from "@/components/icons/IconMines.vue";
import IconTowers from "@/components/icons/IconTowers.vue";
import IconUnbox from "@/components/icons/IconUnbox.vue";
import IconUpgraderGradient from "@/components/icons/IconUpgraderGradient.vue";
import IconLeaderboard from "@/components/icons/IconLeaderboard.vue";
import ChevronLeftIcon from "@/components/icons/ChevronLeftIcon.vue";
import ChatIcon from "@/components/icons/ChatIcon.vue";

export default {
  name: "Sidebar",
  props: {
    mobileOpen: { type: Boolean, default: false },
  },

  components: {
    IconHome,
    IconCrash,
    IconRoll,
    IconBlackjack,
    IconBattles,
    IconDuels,
    IconMines,
    IconTowers,
    IconUnbox,
    IconUpgraderGradient,
    IconLeaderboard,
    ChevronLeftIcon,
    ChatIcon,
  },

  data() {
    return {
      collapsed: false,
      menuGames: [
        { label: "Home", path: "/", icon: IconHome },
        { label: "Slots", path: "/unbox", icon: IconUnbox },
        { label: "Crash", path: "/crash", icon: IconCrash },
        { label: "Roll", path: "/roll", icon: IconRoll },
        { label: "Blackjack", path: "/blackjack", icon: IconBlackjack },
        { label: "Case Battles", path: "/battles", icon: IconBattles },
        { label: "Duels", path: "/duels", icon: IconDuels },
        { label: "Mines", path: "/mines", icon: IconMines },
        { label: "Towers", path: "/towers", icon: IconTowers },
        { label: "Upgrader", path: "/upgrader", icon: IconUpgraderGradient },
      ],
      menuExtra: [
        { label: "Leaderboard", path: "/leaderboard", icon: IconLeaderboard },
      ],
      menuAdmin: [
        { label: "Dashboard", path: "/admin" },
        { label: "Users", path: "/admin/users" },
        { label: "Affiliates", path: "/admin/affiliates" },
        { label: "Promo", path: "/admin/promo" },
        { label: "Cashier", path: "/admin/cashier" },
        { label: "Boxes", path: "/admin/boxes" },
        { label: "Rain", path: "/admin/rain" },
        { label: "Leaderboard", path: "/admin/leaderboard", icon: IconLeaderboard },
        { label: "Filter", path: "/admin/filter" },
        { label: "Stats Book", path: "/admin/stats" },
        { label: "Settings", path: "/admin/settings" },
      ],
    };
  },

  methods: {
    toggleSidebar() {
      this.collapsed = !this.collapsed;
      this.$emit('close-mobile');
    },
    isActive(path) {
      return this.$route.path === path;
    },
    goRain() {
      this.$router.push('/');
      if (this.$store && this.$store.dispatch) {
        this.$store.dispatch('generalSetSidebarMobile', 'Chat');
        this.$nextTick(() => this.$store.dispatch('rainSetDropdownTip', true));
      }
      this.$emit('close-mobile');
    }
  },
  computed: {
    isAdminRoute() {
      return this.$route.matched.some((r) => r.meta.admin === true);
    },
  },
};
</script>

<style scoped>
.sidebar {
  background: rgb(31 31 36);
  color: white;
  height: 100vh;
  width: 19.5rem;
  transition: width 0.3s ease;
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 2rem 0 1rem 2rem;
}
.sidebar.collapsed {
  width: 6.75rem;
}
.logo {
  font-size: 1.5rem;
  font-weight: bold;
  text-align: center;
  margin-bottom: 2rem;
}

.logo-text {
  color: red;
}

.logo img {
  max-width: 120px;
  object-fit: cover;
}
.menu {
  list-style: none;
  padding: 0;
  flex-grow: 1;
}
.menu-item {
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  gap: 1rem;
  cursor: pointer;
  transition: background 0.3s, color 0.3s;
  font-size: 0.875rem;
  font-weight: 600;
  color: rgb(167 166 163);
  border-radius: 0.5rem;
}
.menu-item:hover .menu-icon {
  color: rgb(203 190 137);
}

.menu-item:hover {
  color: #fff;
}

/* Active link styles */
.menu .router-link-exact-active.menu-item,
.menu .menu-item.active {
  color: #ffffff;
  background: rgba(19, 66, 88, 0.15);
}

.menu-icon {
  width: 20px;
  height: 20px;
}
.menu-item-separator {
  width: 100%;
  height: 20px;
}
.sidebar-footer {
  display: flex;
  gap: 1rem;
  padding: 1rem;
  align-items: center;
}
.footer-expanded {
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.footer-collapsed {
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.support-btn {
  border: 2px solid rgb(19 87 77);
  background-color: rgb(15 80 70);
  padding: 0.75rem;
  border-radius: 50px;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: white;
  cursor: pointer;
  flex: 1;
}
.collapse-btn {
  position: absolute;
  top: 3rem;
  right: -15px;
  background: #2a2d32;
  border: none;
  color: white;
  border-radius: 50%;
  width: 35px;
  height: 35px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 30;
}
.lang {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-color: #ffffff16;
  padding: 0.7rem;
  border-radius: 50%;
  position: relative;
}
.flag-img {
  width: 22px;
  height: 22px;
  border-radius: 50%;
}
.rotate-icon {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: -5px;
}

@media only screen and (max-width: 780px) {
  .sidebar {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    transform: translateX(-100%);
    z-index: 40;
    padding: 1.5rem 0 1rem 1.25rem;
    width: 80vw;
    max-width: 320px;
  }
  .sidebar.open { transform: translateX(0); }
}
</style>
